import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { comics, categories } from '@/mocks/data';

interface ComicGridProps {
  currentSlug: string;
}

export default function ComicGrid({ currentSlug }: ComicGridProps) {
  const [activeCategory, setActiveCategory] = useState(currentSlug);
  const navigate = useNavigate();
  const filteredComics = comics.filter((c) => c.category === activeCategory);
  const currentCategory = categories.find((c) => c.slug === activeCategory) || categories[0];

  const handleCategoryChange = (slug: string) => {
    setActiveCategory(slug);
    navigate(`/category/${slug}`, { replace: true });
  };

  return (
    <section className="w-full py-10 md:py-14 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-950">
            {currentCategory.name}<strong className="text-primary-500">漫画</strong>列表
          </h2>

          <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryChange(cat.slug)}
                className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200/70'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
          {filteredComics.length > 0 ? (
            filteredComics.map((comic) => (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className="group block cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-lg mb-2.5 aspect-[2/3]">
                  <img
                    src={comic.imageUrl}
                    alt={comic.title}
                    title={`${comic.title} - 韩漫屋免费韩漫`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-2 right-2 px-1.5 py-0.5 bg-primary-500 text-white text-[10px] rounded-full font-medium">
                    {comic.rating}
                  </div>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
                  {comic.title}
                </h3>
                <div className="flex items-center justify-between mt-1">
                  <span className="text-xs text-foreground-400">{comic.author}</span>
                  <span className="text-xs text-foreground-500">{comic.chapters}话</span>
                </div>
              </Link>
            ))
          ) : (
            <div className="col-span-full text-center py-20">
              <p className="text-foreground-500">暂无该分类的漫画，敬请期待</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}